import { z } from "zod";

import { agentCoverageSchema } from "@/shared/agent-api/responses";

export enum CoverageMaintenance {
  AddSecondary = "add_secondary",
  None = "none",
  ReplacePrimary = "replace_primary",
}

export const coverageMaintenanceSchema = z.enum(CoverageMaintenance);

export enum ReportedInsuranceUsage {
  FallbackWhenMissing = "fallback_when_missing",
  ReplaceStalePrimary = "replace_stale_primary",
}

export const reportedInsuranceUsageSchema = z.enum(ReportedInsuranceUsage);

export const pendingCoverageContextSchema = z
  .strictObject({
    maintenance: z.enum([CoverageMaintenance.AddSecondary, CoverageMaintenance.ReplacePrimary]),
    reportedInsurance: agentCoverageSchema.partial({ plan: true }).strict().optional(),
    reportedInsuranceUsage: reportedInsuranceUsageSchema.optional(),
    verificationPending: z.literal(true),
  })
  .superRefine(({ maintenance, reportedInsurance, reportedInsuranceUsage }, context) => {
    if (reportedInsuranceUsage === ReportedInsuranceUsage.ReplaceStalePrimary && !reportedInsurance) {
      context.addIssue({
        code: "custom",
        path: ["reportedInsurance"],
        message: "Replacing stale primary coverage requires caller-reported insurance",
      });
    }

    if (
      (maintenance === CoverageMaintenance.ReplacePrimary) !==
      (reportedInsuranceUsage === ReportedInsuranceUsage.ReplaceStalePrimary)
    ) {
      context.addIssue({
        code: "custom",
        path: ["reportedInsuranceUsage"],
        message: "Primary replacement and replace-stale-primary usage must be reported together",
      });
    }
  });
export type PendingCoverageContext = z.infer<typeof pendingCoverageContextSchema>;
